import { PureComponent } from "react";

import { BilledStatus } from "types/enum";

import { type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export const BilledStatusDescription = new Map<BilledStatus, string>([
    [BilledStatus.Unknown, ""],
    [BilledStatus.NotBilled, "Not Billed"],
    [BilledStatus.PendingSync, "Pending Sync"],
    [BilledStatus.Billed, "Billed"],
    [BilledStatus.Paid, "Paid"],
]);

export const BillAccountingStatusType = (status: BilledStatus): StatusTypes => {
    switch (status) {
        case BilledStatus.Paid:
            return "success";
        case BilledStatus.PendingSync:
        case BilledStatus.Billed:
            return "pending";
        default:
            return "";
    }
};

interface IBillAccountingStatusTagProps {
    status: BilledStatus;
}

export class BillAccountingStatusTag extends PureComponent<IBillAccountingStatusTagProps> {
    render() {
        const { status } = this.props;
        if (status === BilledStatus.Unknown) {
            return null;
        }
        return (
            <StatusTagDisplay
                statusText={BilledStatusDescription.get(status)}
                statusType={BillAccountingStatusType(status)}
            />
        );
    }
}
